import ApplicationPreviewAboutPosition from './ApplicationPreviewAboutPosition.component';

export default ApplicationPreviewAboutPosition;